'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createContext, useContext, useEffect, useState } from 'react';
import { SafeLocalStorage } from '../lib/safe-local-storage';
var ThemeProviderContext = createContext(undefined);
var safeLocalStorage = new SafeLocalStorage();
export function ThemeProvider(_a) {
    var children = _a.children, _b = _a.defaultTheme, defaultTheme = _b === void 0 ? 'system' : _b, _c = _a.storageKey, storageKey = _c === void 0 ? 'ui-theme' : _c, _d = _a.defaultDisplayMode, defaultDisplayMode = _d === void 0 ? 'computer' : _d, _e = _a.displayModeStorageKey, displayModeStorageKey = _e === void 0 ? 'ui-display-mode' : _e, props = __rest(_a, ["children", "defaultTheme", "storageKey", "defaultDisplayMode", "displayModeStorageKey"]);
    var _f = useState(function () { return safeLocalStorage.getItem(storageKey) || defaultTheme; }), theme = _f[0], setTheme = _f[1];
    var _g = useState(function () { return safeLocalStorage.getItem(displayModeStorageKey) || defaultDisplayMode; }), displayMode = _g[0], setDisplayMode = _g[1];
    useEffect(function () {
        var root = window.document.documentElement;
        // Add or remove the tv-mode class
        if (displayMode === 'tv') {
            root.classList.add('tv-mode');
        }
        else {
            root.classList.remove('tv-mode');
        }
        // Add or remove the light or dark class
        root.classList.remove('light', 'dark');
        if (theme === 'system') {
            var systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
                ? 'dark'
                : 'light';
            root.classList.add(systemTheme);
            return;
        }
        root.classList.add(theme);
    }, [theme, displayMode]);
    var value = {
        theme: theme,
        setTheme: function (theme) {
            safeLocalStorage.setItem(storageKey, theme);
            setTheme(theme);
        },
        displayMode: displayMode,
        setDisplayMode: function (displayMode) {
            safeLocalStorage.setItem(displayModeStorageKey, displayMode);
            setDisplayMode(displayMode);
        },
    };
    return (<ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>);
}
export var useTheme = function () {
    var context = useContext(ThemeProviderContext);
    if (context === undefined)
        throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};
